export default __webpack_public_path__ + "static/keys-e841cf9b64f8bd6b82e87f04476d338d.png";